// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hcle","tabsBox":"styles_tabsBox__1rU5Z","createButton":"styles_createButton__pGSdY"};